import { useState } from "react";
import { useUser } from "../context";
import { ToastEmitter } from "../Services/assets/toast-emitter";

export const build_config = ({ myConfig, access_token, brand }) => {
	return {
		...myConfig,
		headers: {
			...myConfig?.headers,
			Authorization: `Bearer ${access_token}`,
			"x-brand": brand?._id,
		},
	};
};

export function UseApi({ service, config: myConfig, param, successMsg }) {
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [isLoading, setLoading] = useState(false);
	const {
		tokens: { access_token, group },
		brand,
	} = useUser();

	const fetch = async (body, isSilent) => {
		try {
			if (!isSilent) {
				setLoading(true);
				setError(null);
				setData(null);
			}
			const config = build_config({ myConfig, access_token, brand });
			const res = await service({ config, body, param, group });
			console.info(service.name, res);
			if (successMsg)
				ToastEmitter({
					type: "success",
					msg: successMsg,
				});
			setData(res);
			setLoading(false);
			return res;
		} catch (err) {
			setError(err);
			console.info(service.name, err);
			setLoading(false);
			return null;
		}
	};

	return [{ data, isLoading, error }, fetch];
}
